import React from "react";
import PropTypes from "prop-types";
import TextField from "@material-ui/core/TextField";

class TextValue extends React.Component {
  static propTypes = {
    current: PropTypes.string,
    handleChange: PropTypes.func,
    inputRef: PropTypes.object
  };
  render() {
    const {current, handleChange, inputRef} = this.props;
    return (
      <div className="text-value">
        <TextField
          id="outlined-multiline-flexible"
          fullWidth
          multiline
          rowsMax="4"
          value={current}
          onChange={handleChange(`text`)}
          className="text-control__textarea"
          margin="normal"
          variant="outlined"
          inputRef={inputRef}
        />
      </div>
    );
  }
}

export default TextValue;
